import React, { useEffect, useState } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";
import {
  HeaderSkeleton,
  PaginationSkeleton,
  TableSkeleton,
} from "../Skelton/Skelton";
const EditRole = () => {
  const {
    baseUrl,
    openToast,
    roleName,
    setRoleName,
    roleId,
    setEditPermissions,
    editPermissions: permissions,
    fetchRoles,
    roles,
    name,
    setRoles,
    staffs
  } = useGlobalContext();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const recordsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const result = await fetchRoles(currentPage);
      setRoles(result.data);
      setTotalPages(result?.totalPages);
      setTotalRecords(result.totalRecords);
      setIsLoading(false);
    };
    fetchData();
  }, [currentPage]);

  const handlePermissionChange = (section, permission) => {
    setEditPermissions((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [permission]: !prev[section][permission],
      },
    }));
  };

  async function updateRole() {
    try {
      setIsLoading(true);
      const response = await fetch(baseUrl + "role/" + roleId, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ roleName: name?.role_name, permissions }),
      });

      const data = await response.json();
      if (response.status === 200) {
        navigate("/role-detail");
        openToast("Update Role Successfully", "success");
        fetchRoles();
      } else {
        openToast("An error occurred", "error");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (roleName === "" || roleId === "") {
      navigate("/role-detail");
    }
  }, [roleName, roleId, navigate]);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const filteredStaffs = staffs?.filter((staff) => staff?.staffDetails?.role?.id === roleName?.id);

  return (
    <div className="flex lg:flex-row flex-col sm:flex-col md:flex-col gap-1 pt-[30px] pl-[10px]">
      <div className="mb-3 pr-2 pb-4 pl-[10px] w-[100%] sm:w-[100%] md:w-[100%] lg:w-[50%] addnewrole">
        <h2 className="font-medium text-[16px]">Edit Role Content Writer</h2>

        <div className="bg-[#fff] shadow-cs mt-2 p-3 rounded-md w-[100%] sm:w-[100%] md:w-[100%]">
          <label>Role Name</label>
          <br />
          <input
            type="text"
            className="mt-2 pr-7 pl-3 border border-1 rounded-md focus:outline-none w-[100%] h-[43px] text-[#aeabab] text-[15px]"
            value={roleName?.role_name}
            onChange={(e) => setRoleName(e.target.value)}
          />

          <table className="mt-5 border border-1 w-[100%]">
            <thead className="border border-1">
              <tr>
                <th className="p-2 border-r-[1px] font-medium text-left">
                  Features
                </th>
                <th className="p-2 font-medium text-left">Capabilities</th>
              </tr>
            </thead>
            <tbody className="table-body-set">
              {/* Clients Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Clients
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "clients_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.create}
                    onChange={() =>
                      handlePermissionChange("clients_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("clients_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("clients_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Projects Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Projects
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "projects_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.create}
                    onChange={() =>
                      handlePermissionChange("projects_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("projects_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("projects_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Report Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Report
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.report_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "report_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.report_permissions.view_time_sheets}
                    onChange={() =>
                      handlePermissionChange(
                        "report_permissions",
                        "view_time_sheets"
                      )
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    View Timesheets Report
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Setting Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Setting
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.settings_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "settings_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.settings_permissions.view_time_sheets}
                    onChange={() =>
                      handlePermissionChange(
                        "settings_permissions",
                        "view_time_sheets"
                      )
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    View Timesheets Report
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Staff Role Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Staff Role
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "staff_role_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.create}
                    onChange={() =>
                      handlePermissionChange("staff_role_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("staff_role_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("staff_role_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Staff  Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Staff{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "view_global")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.create}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Task  Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "view_global")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.create}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Sub Task  Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Sub Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "sub_task_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.create}
                    onChange={() =>
                      handlePermissionChange("sub_task_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[13px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("sub_task_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("sub_task_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Chat Module Section */}
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Chat Module
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.chat_module_permissions.grant_access}
                    onChange={() =>
                      handlePermissionChange(
                        "chat_module_permissions",
                        "grant_access"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[13px] cursor-pointer">
                    Grant Access
                  </label>
                  <br />
                </td>
              </tr>
            </tbody>
          </table>

     
          <div className="flex justify-end gap-2 mt-3">
            <Link to="/role-detail" className="flex items-center first-btn">
              Cancel
            </Link>
            <button
              className={`second-btn ${isLoading == true ? "opacity-50 cursor-not-allowed" : ""
                }`}
              onClick={updateRole}
            >
              Update
            </button>
          </div>
        </div>
      </div>

       {/* Staff members list */}
       <div className="p-[10px] w-[100%] sm:w-[100%] md:w-[100%] lg:w-[50%] staff-member">
        <h2 className="font-medium text-[16px]">
          Staff members using this role
        </h2>

        <div className="bg-[#fff] shadow-cs mt-2 p-2 rounded-md">
          <div className="">
            <h2 className="bg-[#fff] shadow-cs mb-2 p-2 border border-t-1 border-r-0 border-b-1 border-l-0 rounded-md">
              Roles  
            </h2>

            <div className="title">
            {filteredStaffs?.length > 0 ? (
                filteredStaffs.map((item, index) => (
                  <h3 key={item.id} className="px-[5px] py-[7px] border-b text-grey-400">
                    {index + 1}. {item?.name}
                  </h3>
                ))
              ) : (
                <p className="px-[5px] py-[7px] text-center text-red-500 ">No staff members found</p>
              )}
            </div>

         

            {/* Pagination */}
            {filteredStaffs?.length > 0 && (
              <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-4 w-full">
                {isLoading ? (
                  <PaginationSkeleton />
                ) : (
                  <>
                    <p className="text-gray-500 text-sm">
                      Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                      {Math.min(currentPage * recordsPerPage, totalRecords)} of {totalRecords} entries
                    </p>
                    <div className="flex gap-2 p-0 border rounded-md pagination">
                      <button
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                        className={`px-3 py-2 text-xs ${currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""}`}
                      >
                        Previous
                      </button>
                      <span className="flex items-center bg-purple-900 px-3 text-white text-xs">{currentPage}</span>
                      <button
                        onClick={handleNext}
                        disabled={currentPage >= totalPages}
                        className={`px-3 py-2 text-xs ${currentPage >= totalPages ? "opacity-40 cursor-not-allowed" : ""}`}
                      >
                        Next
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRole;
